module.exports = __webpack_public_path__ + "static/img/mode-group_check@2x.5ab1302c.png";